import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import DateFormatSelection from './DateFormatSelection';
import TimeFormatSelection from './TimeFormatSelection';
import TimeZoneSelection from './TimeZoneSelection';
import { saveTimeZoneSelection, saveDateFormatSelection, saveTimeFormatSelection, } from '../orchestration/saveRegionalOption';
var styles = require('./Regional.scss');
var RegionalQuickSelection = /** @class */ (function (_super) {
    tslib_1.__extends(RegionalQuickSelection, _super);
    function RegionalQuickSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegionalQuickSelection.prototype.render = function () {
        return (React.createElement("div", { className: styles.quickSettingWrapper },
            React.createElement("div", { className: styles.quickSettingOption },
                React.createElement(TimeZoneSelection, { onSave: saveTimeZoneSelection })),
            React.createElement("div", { className: styles.quickSettingOption },
                React.createElement(DateFormatSelection, { showExampleWithDateFormatLabel: false, onSave: saveDateFormatSelection })),
            React.createElement("div", { className: styles.quickSettingOption },
                React.createElement(TimeFormatSelection, { onSave: saveTimeFormatSelection }))));
    };
    RegionalQuickSelection = tslib_1.__decorate([
        observer
    ], RegionalQuickSelection);
    return RegionalQuickSelection;
}(React.Component));
export default RegionalQuickSelection;
//# sourceMappingURL=RegionalQuick.js.map